import { render } from "./ListSections.vue?vue&type=template&id=98e1a9e6&scoped=true"
import script from "./ListSections.vue?vue&type=script&lang=js"
export * from "./ListSections.vue?vue&type=script&lang=js"

import "./ListSections.vue?vue&type=style&index=0&id=98e1a9e6&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98e1a9e6"]])

export default __exports__